import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function CircularProgressWithLabel(props) {
  return (
    <Box>
      <Box sx={{ position: 'relative' }}>
        <CircularProgress variant="determinate" {...props} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            width: '100%',
            height: '100%',
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: 'white', fontWeight: 'bold' }}
          >{`${Math.round(props.value)}%`}</Typography>
        </Box>
      </Box>
    </Box>

  );
}

export default CircularProgressWithLabel;